var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","px-3":""}},[_c('v-flex',{attrs:{"xs2":"","align-self-end":""}},[_c('table-columns')],1),_c('v-flex',[_c('list',{attrs:{"items":_vm.filteredItems,"rowsPerPage":_vm.rowsPerPage}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }